import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorText, colorTextMedium } = theme();

  return StyleSheet.create({
    label: {
      color: colorText,
    },
    value: {
      color: colorTextMedium,
    },
  });
};

export { style };
